import { User } from 'lib/types/users';
import {
  compact, reject, sortBy, uniqBy,
} from 'lodash';

/**
 * Take an array of any kind of user, compact them (in case there are undefineds mixed in),
 * make them unique (on their ID), and remove the current user if it's in the list.
 */
export function uniqueUsers(suggestions: User[], currentUserId?: number, limit = 4) {
  return reject(
    uniqBy(
      compact(suggestions), 'username',
    ), (u) => u.id === currentUserId,
  ).splice(0, limit);
}

/**
 * Apply the same logic as `uniqueUsers`, but sort companies to the top.
 */
export function uniqueCompanies(suggestions: User[], currentUserId?: number, limit = 4) {
  return uniqueUsers(
    sortBy(suggestions, 'userTypeId'), currentUserId, limit,
  );
}
